import { ObjectId, Document } from 'mongoose'
import { Adder, BrowserConsentMetadata, LoanApplication, SLoanApplication, LoanDocument, Adders } from '.'

export enum ChangeOrderStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Cancelled = 'cancelled'
}

export enum ChangeOrderCommentTitle {
  InstallerSubmitted = 'Installer Submitted Pending Change Order',
  ConsumerApproved = 'Consumer Approved Change Order'
}

export interface IChangeOrder {
  _id?: string | ObjectId

  // Reference to the original loan application
  loanApplicationId: string | ObjectId
  status: ChangeOrderStatus

  adders?: Adder[]
  teslaPowerwallQty?: number
  storageQty?: number
  systemSizeKW?: number
  storageCapacity?: number
  ppWForPV?: number
  ppwForStorage?: number
  solarCost?: number

  createdDate: Date
  updatedDate: Date
  lastResentAt?: Date
  submittedAt?: Date
  resolvedAt?: Date

  submittedBy: string // installer email/ID
  customerAgreesToChangeOrder?: BrowserConsentMetadata | boolean

  // Post-NTP change order fields
  isPostNTP?: boolean
  loanModFee?: number
  feeCoveredBy?: 'installer' | 'consumer'
  vendorAchDocument?: LoanDocument
  loanModForm?: LoanDocument
  installerNotes?: string

  data(): Partial<LoanApplication>
  plainTextSummary(tempLapp: SLoanApplication, title: ChangeOrderCommentTitle): string
  buildNonCreditAdderLines(originalAdders: Adders, changesAdders: Adders): string[]
} 

export type ChangeOrder = IChangeOrder & Document
